import { ExternalLinkBlock, InternalLinkBlock } from "../components/link/types";
import type { BreadcrumbData as BreadcrumbsData } from "../components/Breadcrumbs";
import type { NavigationRootMenu } from "../components/Header";

export const updateBreadcrumbTitleFromPayload = (
  breadcrumbs: readonly BreadcrumbsData[],
  breadcrumbTitle: string | null
): BreadcrumbsData[] => {
  if (breadcrumbTitle) {
    breadcrumbs[breadcrumbs.length - 1].label = breadcrumbTitle;
  }
  return [...breadcrumbs];
};

export const checkIfActiveLabelInParentNode = (
  menuNavigation: (
    | InternalLinkBlock
    | ExternalLinkBlock
    | NavigationRootMenu
  )[],
  label?: string
): string | undefined => {
  if (!label) {
    return;
  }

  for (const item of menuNavigation) {
    if ("links" in item && item.links.length > 0) {
      const isMatch = searchLinksForLabel(item.links, label);
      if (isMatch) {
        return item.label;
      }
    }
  }

  return;
};

const searchLinksForLabel = (
  links: NavigationRootMenu["links"],
  targetLabel: string
): boolean => {
  for (const link of links) {
    if ("label" in link && link.label === targetLabel) {
      return true;
    }

    if ("links" in link && searchLinksForLabel(link.links, targetLabel)) {
      return true;
    }
  }

  return false;
};
